import React, { useEffect } from 'react';

function Notification({ message, type }) {
  useEffect(() => {
    const timer = setTimeout(() => {}, 4000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`notification notification-${type}`}>
      <div className="notification-content">
        <i className={`notification-icon fas ${type === 'success' ? 'fa-check-circle' : type === 'error' ? 'fa-exclamation-circle' : 'fa-info-circle'}`}></i>
        <span>{message}</span>
      </div>
    </div>
  );
}

export default Notification;
